var exports = {
  "W": "xa15a2ab7--837d95--info-layout",
};

module.exports = exports;
